<template>
  <div class="day-view">
    <div class="time-column">
      <div v-for="slot in timeSlots" :key="slot" class="time-label">
        {{ formatTime(slot) }}
      </div>
    </div>
    <!-- Область слотов с обработчиками dragover и drop -->
    <div class="day-slots" @dragover.prevent @drop="onDrop($event)">
      <!-- Временные слоты (для клика, например, для создания новой задачи) -->
      <div
        v-for="slot in timeSlots"
        :key="slot"
        class="time-slot"
        @click="slotClick(slot)"
      ></div>
      <!-- Задачи текущего дня, которые можно перетаскивать -->
      <div
        v-for="task in tasksForCurrentDay"
        :key="task.id"
        class="calendar-task"
        draggable="true"
        @dragstart="onDragStart($event, task)"
        @click.stop="taskClick(task)"
        :style="getTaskStyle(task)"
      >
        {{ task.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DayView",
  props: {
    currentDate: { type: Date, required: true },
    tasks: { type: Array, default: () => [] }
  },
  computed: {
    timeSlots() {
      const slots = [];
      for (let t = 7; t <= 18; t += 0.5) {
        slots.push(Number(t.toFixed(1)));
      }
      return slots;
    },
    tasksForCurrentDay() {
      const ymd = this.formatDate(this.currentDate);
      return this.tasks.filter(t => t.date === ymd);
    }
  },
  methods: {
    slotClick(slot) {
      this.$emit("timeSlotClick", this.currentDate, slot);
    },
    taskClick(task) {
      this.$emit("taskClick", task);
    },
    onDragStart(event, task) {
      // Передаем id задачи (как строку) в dataTransfer
      event.dataTransfer.setData("text/plain", String(task.id));
      event.dataTransfer.effectAllowed = "move";
    },
    onDrop(event) {
      // Используем event.currentTarget (область day-slots)
      const rect = event.currentTarget.getBoundingClientRect();
      const offsetY = event.clientY - rect.top;
      const cellHeight = 30; // Высота одного временного слота (в пикселях)
      const slotIndex = Math.floor(offsetY / cellHeight);
      const newStartTime = 7 + slotIndex * 0.5;
      
      const data = event.dataTransfer.getData("text/plain");
      if (!data) return;
      
      // Если данные начинаются с "order:" – это заказ, иначе задача
      if (data.startsWith("order:")) {
        this.$emit("taskDropped", { taskId: data, newDate: this.currentDate, newStartTime });
      } else {
        this.$emit("taskDropped", { taskId: data, newDate: this.currentDate, newStartTime });
      }
    },
    getTaskStyle(task) {
      const baseHour = 7;
      const cellHeight = 30;
      // Используем либо start_hour либо startHour
      const taskStart = task.start_hour !== undefined ? task.start_hour : task.startHour;
      const intervalsFromStart = (taskStart - baseHour) * 2;
      const topOffset = intervalsFromStart * cellHeight;
      const intervalsDuration = task.duration * 2;
      const height = intervalsDuration * cellHeight;
      return {
        position: "absolute",
        top: topOffset + "px",
        left: "4px",
        right: "4px",
        height: (height - 4) + "px",
        backgroundColor: "#4A90E2",
        color: "#fff",
        border: "1px solid #357ABD",
        borderRadius: "4px",
        padding: "2px 4px",
        boxSizing: "border-box",
        overflow: "hidden",
        fontSize: "12px"
      };
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    formatTime(num) {
      const hour = Math.floor(num);
      const minutes = num % 1 ? "30" : "00";
      return hour.toString().padStart(2, "0") + ":" + minutes;
    }
  }
};
</script>

<style scoped>
.day-view {
  display: flex;
  height: 100%;
}
.time-column {
  width: 50px;
  border-right: 1px solid #ccc;
}
.time-label {
  height: 30px;
  line-height: 30px;
  text-align: right;
  padding-right: 4px;
  font-size: 12px;
  border-bottom: 1px solid #eee;
}
.day-slots {
  flex: 1;
  position: relative;
  /* Задаем минимальную высоту для полного охвата слотов */
  min-height: calc(30px * 23);
}
.time-slot {
  height: 30px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.calendar-task {
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
}
</style>
